import { render, staticRenderFns } from "./TgNyjDownloadPage.vue?vue&type=template&id=66a7a9dc&"
import script from "./TgNyjDownloadPage.vue?vue&type=script&lang=js&"
export * from "./TgNyjDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports